import { KeyboardBackspace as Arrow } from '@mui/icons-material';
import { Link } from '@on3/ui-lib/components/Link';
import { SiteThemes } from '@on3/ui-lib/utils/sites';
import clsx from 'clsx';

import styles from './LinkButton.module.scss';

interface ILinkButtonProps {
  type: SiteThemes;
  className?: string;
}
export const LinkButton = ({ type, className }: ILinkButtonProps) => {
  let link;

  if (type === SiteThemes.ON3) {
    link = {
      title: 'Find your team',
      href: '/teams/',
    };
  } else if (type === SiteThemes.RIVALS) {
    link = {
      title: 'High School',
      href: '/high-school/',
    };
  }

  if (!link) return null;

  return (
    <Link
      className={clsx(styles.component, className, {
        [styles.rivals]: type === SiteThemes.RIVALS,
      })}
      data-ui="link-button"
      href={link.href}
    >
      {link.title}
      <Arrow />
    </Link>
  );
};
